module.exports = __webpack_public_path__ + "static/050_Gippsland-5fa6909e4de64cc4cec3ae4b5440049b.jpg";